import './MultiReferenceToolbar.css';

import { PlusIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { Button } from '@/components/core/Button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@/components/core/DropdownMenu/DropdownMenu';
import { Icon } from '@/components/core/Icon';
import useCustomItemEditorSettings from '@/hooks/useCustomItemEditorSettings';
import { useTranslation } from '@/hooks/useTranslation';

interface MultiReferenceToolbarProps {
    onOpenSelectDialog: () => void;
    onOpenCreateDialog: () => void;
    fieldPath: string;
    hierarchyAttributeName?: string;
}

export const MultiReferenceToolbar = ({
    onOpenSelectDialog,
    onOpenCreateDialog,
    fieldPath,
    hierarchyAttributeName
}: MultiReferenceToolbarProps) => {
    const [isDropdownBtnOpen, setDropdownBtnIsOpen] = useState(false);
    const { t } = useTranslation();
    const { getValues } = useFormContext();
    const {customItemEditorSettings} = useCustomItemEditorSettings();
    const enableCreateNewItem = customItemEditorSettings?.enableCreateHierarchyItemTemplate(getValues(), hierarchyAttributeName);

    return (
        <div className="tw-flex tw-justify-end">
            <DropdownMenu open={isDropdownBtnOpen} onOpenChange={setDropdownBtnIsOpen}>
                <DropdownMenuTrigger asChild>
                    <Button variant='default' id={`${fieldPath}-btn`}>
                        <span className="tw-flex tw-items-center">
                            <Icon icon={PlusIcon} size="sm" variant="light" />
                            <span className="tw-ml-2">{t('ADD_ITEM')}</span>
                        </span>
                    </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent hasBorder={true} hasPadding={false}>
                    <ul className="tw-list-none tw-p-0 tw-m-0">
                        <li>
                            <button
                                id={`${fieldPath}-add-existing-btn`}
                                type="button"
                                onClick={() => { onOpenSelectDialog(); setDropdownBtnIsOpen(false); }}
                                className={
                                    `add-existing-btn tw-duration-100 tw-ease-out tw-border-none tw-p-2 tw-shadow-none
                                    tw-bg-fill-primary tw-text-t-sm lg-font-dynamic tw-text-t-primary
                                    hover:tw-bg-fill-primary-hover tw-w-full tw-text-left`}
                            > {t('MULTI_REFERENCE.SELECT_EXISTING_ITEM')}</button>
                        </li>
                        { enableCreateNewItem && <li>
                            <button
                                id={`${fieldPath}-create-new-btn`}
                                type="button"
                                onClick={() => { onOpenCreateDialog(); setDropdownBtnIsOpen(false); }}
                                className={
                                    `create-new-btn tw-duration-100 tw-ease-out tw-p-2 tw-shadow-none
                                    tw-bg-fill-primary tw-text-t-sm lg-font-dynamic tw-text-t-primary
                                    hover:tw-bg-fill-primary-hover tw-w-full tw-text-left tw-border-b-0
                                    tw-border-r-0 tw-border-l-0 tw-border-t tw-border-primary`}
                            > {t('CREATE_NEW_ITEM')}</button>
                        </li>}
                    </ul>
                </DropdownMenuContent>
            </DropdownMenu>
        </div>
    );
};

